<template>
    <div style="bottom:15%;right: 1%; z-index: 1; position: fixed;width: 100%;">
        <b-link :to="{name:goTo}" class="preTitle mt-1" style="color: #5E8F23">{{preTitle}}</b-link>
        <b-button class="plusButton mr-1 px-0 pt-0 pb-0">
            <b-link :to="{ name: goTo }">
                <b-img width="50px" 
                    src="@/assets/images/ganImage/icons/add.png"
                />
            </b-link>
        </b-button>
    </div>
</template>
<script>
import {BImg, BLink, BButton} from 'bootstrap-vue'
export default {
    props:{
        preTitle:String,
        goTo:String
    },
    components: {
        BImg,
        BLink,
        BButton,
    },
    data() {
        return {}
    }
}
</script>
<style lang="scss">

.plusButton {
    background-color: transparent !important;
    position: absolute;
    border: 0;
    top:83%;
    right:1%;
    //border-radius:50%;
}

.preTitle {
    position: absolute;
    top:100%;
    right:20%;
    color: #5E8F23;
    font-weight: 600;
    font-size: medium;
}
</style>